import { createReducer } from "@reduxjs/toolkit";
import { clientUrlBasePath } from "common/utilities/browser/url/url";
import {
  clientBuildIdLoaded,
  configurationLoaded,
  endpointsInitialized,
  loadingConfiguration,
  loadingConfigurationFailed,
} from "core/redux/actions/configuration/configurationActions";

import type { ConfigurationState } from "./configurationReducer.types";

export const initialState = (): ConfigurationState => ({
  configuration: {
    admin_email: "helpdesk@genedata.com",
    app_name: "Selector",
    default_first_page_url: clientUrlBasePath(),
    format_pattern_date: "yyyy-MM-dd",
    format_pattern_date_with_time: "yyyy-MM-dd HH:mm:ss",
    login_flow: "plain",
    table_export_import_format: "csv",
    client_bx2_header_logo: "",
    client_bx2_header_title_1: "",
    client_bx2_footer_logo: "",
    client_bx2_footer_url: "",
  },
  loading: false,
  loadingError: false,
  jsfContextPath: "",
  jsfUrl: "",
  apiUrl: "",
  imgRootUrl: "",
  timeZone: "Europe/Zurich",
});

const configurationReducer = () =>
  createReducer(initialState(), (builder) =>
    builder

      .addCase(clientBuildIdLoaded, (state, action) => ({ ...state, clientBuildId: action.payload.clientBuildId }))

      .addCase(endpointsInitialized, (state, action) => ({ ...state, ...action.payload }))

      .addCase(loadingConfiguration, (state) => ({ ...state, loading: true, loadingError: false }))

      .addCase(configurationLoaded, (state, action) => ({
        ...state,
        loading: false,
        loadingError: false,
        configuration: action.payload.configuration,
        timeZone: action.payload.timeZone,
      }))

      .addCase(loadingConfigurationFailed, (state) => ({ ...state, loading: false, loadingError: true }))
  );

export default configurationReducer;
